import { Auth } from "aws-amplify";

const deleteUser = async () => {
  await Auth.deleteUser();
};

export default deleteUser;
